import { render, staticRenderFns } from "./XiangMu_辉县版本.vue?vue&type=template&id=56fa86f4&scoped=true"
import script from "./XiangMu_辉县版本.vue?vue&type=script&lang=js"
export * from "./XiangMu_辉县版本.vue?vue&type=script&lang=js"
import style0 from "./XiangMu_辉县版本.vue?vue&type=style&index=0&id=56fa86f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa86f4",
  null
  
)

export default component.exports